import supportedLocaleKeys from 'locales/supported-locales.json';

export const REFRESH_INTERVAL = 600000;

const localeNames = {
  'fr-FR': 'Français',
  'en-US': 'English (United States)',
  'de-DE': 'Deutsch',
  'nl-NL': 'Nederlands',
  da: 'Dansk',
  ja: '日本語',
  nb: 'Bokmål',
  pt: 'Português',
  'pt-BR': 'Português (Brasil)',
  es: 'Español',
  sv: 'Svenska',
};

// NOTE: This value is needed for when the language management tool feature flag is disabled.
//       When we remove the old logic to get all the supported locales, this will be removed.
export const supportedLocales = supportedLocaleKeys.map(locale => ({
  languageName: localeNames[locale],
  localeKey: locale,
}));

export const defaultLocaleKey = 'en-US';

export const defaultLocaleData = {
  languageName: localeNames[defaultLocaleKey],
  localeKey: defaultLocaleKey,
};
